import BlockModel from '../models/email-template/block-model.interface';

export class PreviewBlockHelper {
  static findBlock(blocks: BlockModel[], name: string): BlockModel | undefined {
    return blocks.find((b) => b.name === name);
  }

  static getVar(block: BlockModel | undefined, key: string): string {
    return block?.variables?.[key] ?? '';
  }

  /**
   * Collect non-empty `${prefix}1..${max}` variables from the first block of
   * the given name (e.g. Headline_1..3 on the 'headline' block).
   */
  static collectFromBlock(
    blocks: BlockModel[],
    name: string,
    prefix: string,
    max: number,
  ): string[] {
    const block = this.findBlock(blocks, name);
    if (!block) {
      return [];
    }
    const values: string[] = [];
    for (let i = 1; i <= max; i++) {
      const value = this.getVar(block, `${prefix}${i}`).trim();
      if (value) {
        values.push(value);
      }
    }
    return values;
  }
}
